import { useEffect } from "react";

const useKeyPress = (keyName: string, onKeyPress: () => void) => {
    useEffect(() => {
        const handleKeyPress = (e: KeyboardEvent) => {
            if (e.key === keyName) {
                onKeyPress();
            }
        };
        document.addEventListener("keyup", handleKeyPress, false);

        return () => {
            document.removeEventListener("keyup", handleKeyPress, false);
        };
    }, [keyName, onKeyPress]);
};

export default useKeyPress;
